import React from 'react';
import { IS_CLIENT } from '../../config/constant';
import ClientLogoIcon from '../../images/client-logo.png';

export const ClientLogo = ({ className }) =>
	IS_CLIENT ? <img src={ClientLogoIcon} className={className} alt={''} /> : <></>;
